'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _createLoginClient = require('../../helpers/createLoginClient');

var _createLoginClient2 = _interopRequireDefault(_createLoginClient);

var _Error = require('../../helpers/Error');

var _ClientError = require('../../helpers/ClientError');

var _Version = require('./Version.scss');

var _Version2 = _interopRequireDefault(_Version);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Version = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth, version: state.appInfo.version };
}, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Version, _Component);

  function Version() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Version);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Version.__proto__ || (0, _getPrototypeOf2.default)(Version)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      beVersion: '',
      sumUrl: ''
    }, _this.componentDidMount = function () {
      (0, _createLoginClient2.default)().then(function (loginClient) {
        return loginClient.root.getServerInfo({}, { responseContentType: 'application/json' }).then(function (result) {
          _this.setState({ beVersion: result.obj.version });
          _this.setState({ sumUrl: result.obj.sumUrl });
        }).catch(function (error) {
          (0, _Error.logError)(error.statusText);
        });
      }).catch(function (error) {
        (0, _ClientError.createLoginClientError)(error, new Error().stack, _this.props.pushState, _this.props.auth);
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Version, [{
    key: 'render',
    value: function render() {
      var feVersion = this.props.version;
      var _state = this.state,
          beVersion = _state.beVersion,
          sumUrl = _state.sumUrl;


      return _react2.default.createElement(
        'div',
        { className: _Version2.default.versionComponent },
        _react2.default.createElement(
          'div',
          { className: _Version2.default.title },
          Version
        ),
        _react2.default.createElement(
          'div',
          { className: _Version2.default.version },
          'FE: ' + feVersion + ' BE: ' + beVersion
        ),
        _react2.default.createElement(
          'div',
          { className: _Version2.default.version },
          'Sum Url: ' + sumUrl
        ),
        _react2.default.createElement(
          'div',
          { id: 'version', className: _Version2.default.hidden },
          feVersion
        )
      );
    }
  }]);
  return Version;
}(_react.Component), _class2.propTypes = {
  pushState: _react.PropTypes.func.isRequired,
  auth: _react.PropTypes.object,
  version: _react.PropTypes.string
}, _temp2)) || _class);
exports.default = Version;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Version/Version.js
// module id = 2028
// module chunks = 0